export const TournamentClosestToPinRange = `query getClosestToPinRangeLeaderboard(
  $publishedTournamentId: ID!
  $playerIds: [ID!]!
  $gender: Gender
  $nationality: [String!]
  $searchText: String
  $skip: Int
  $take: Int
) {
  node(id: $publishedTournamentId) {
    ...ClosestToPinTournamentFragment
  }
}
  
fragment ClosestToPinTournamentFragment on ClosestToPinTournament {
  dbId
  name
  unit
  tournamentState
  holes {
    holeNumber
    pinId
  }
  leaderboard(gender: $gender) {
    records(
      skip: $skip
      take: $take
      searchText: $searchText
      nationality: $nationality
      gender: $gender
    ) {
      items {
        gender
        playername
        playerId
        age
        nationality
        email
        total {
          distanceToPin
          distanceToPinWithPenalty
          state
        }
        average {
          distanceToPin
          distanceToPinWithPenalty
        }
        holes {
          holeNumber
          distance
          filterPos
          filterPosLabel
          pos
          posLabel
          distanceToPin
          distanceToPinWithPenalty
          lie
          penalty
          state
        }
        score {
          posLabel
          pos
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
    selectedPlayers(ids: $playerIds) {
      playerId
      playername
      nationality
      total {
        distanceToPin
        distanceToPinWithPenalty
        state
      }
      holes {
        distance
        distanceToPin
        distanceToPinWithPenalty
        filterPos
        filterPosLabel
        holeNumber
        lie
        penalty
        pos
        posLabel
        state
      }
      average {
        distanceToPin
        distanceToPinWithPenalty
        state
      }
      score {
        posLabel
        pos
      }
    }
  }
}
`;
